import { useQuery } from "@tanstack/react-query";
import * as React from "react";
import AboutManagementTeam from "../../components/aboutManagementTeam";
import Spinner from "../../components/spinner";
import { BASE_URL } from "../../data/baseURL";
import { useScrollTop } from "../../hook/useScrollTop";
const DirectorsDetailsModal = React.lazy(() =>
  import("../../components/directoes-details-modal")
);
const ExecutiveAndLeadershipTeam = () => {
  const { data, isLoading } = useQuery(["managementTeams"], async () => {
    const response = await window.fetch(`${BASE_URL}/management`);
    // const response = await window.fetch(`${BASE_URL}/management-teams`);
    return await response.json();
  });
  const management_team = data?.datas;

  useScrollTop();

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <section className="d-none d-lg-block position-sticky top-0 w-100">
        <ul className="d-flex justify-content-around fs-14 text-center p-0 m-0 align-items-stretch">
          {management_team.map((data, index) => (
            <li
              key={index}
              className="list-style-none submenu-link border-gray w-100 d-flex align-items-center justify-content-center"
            >
              <a
                href={`#${data?.id}`}
                className="text-decoration-none gilroy-bold d-block py-3"
              >
                {data?.title}
              </a>
            </li>
          ))}
        </ul>
      </section>
      {/* <TableOfContents routes={solarAlternativeSubMenus} /> */}
      <section className="me-35 ms-35 pt-5">
        <div className="row">
          {management_team?.map((data, index) => (
            <div className="col-12" key={index} id={`${data?.id}`}>
              <h4 className="fs-38 lh-40 gilroy-bold mt-4">{data?.title}</h4>
              <hr className="mb-5" />
              <div className="row">
                {data?.about_management_team?.map((team, index) => (
                  <AboutManagementTeam team={team} index={index} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default ExecutiveAndLeadershipTeam;
